import { useDispatch } from 'store/hooks';
import { setAppMode } from './actions';
import { AppMode } from './AppMode';

export const useDispatchSetAppMode = () => {
    const dispatch = useDispatch();
    return (appMode: AppMode) => {
        dispatch(setAppMode(appMode));
    };
};
